import React from 'react'
import RadioButton from "../../Inputs/Radio/index";

export const TratoComponent = ({ title = "Trato", h = "h3", onChange = () => { }, value = "" }) => {
    return (
        <section className="w-100 mb-5">
            {
                h === "h2" ? <h2>{title}</h2> : <h3>{title}</h3>
            }
            <div className="d-flex flex-column flex-md-row gap-4" onChange={onChange}>
                <RadioButton label="Sr." name="tratamiento" value="Sr" defaultChecked={value === "Sr"} />
                <RadioButton label="Sra." name="tratamiento" value="Sra" defaultChecked={value === "Sra"} />
                <RadioButton label="Srita." name="tratamiento" value="Srita" defaultChecked={value === "Srita"} />
            </div>
        </section>
    )
}
